const ProgressionCheckbox = ({
  name,
  onChange,
  children,
  disabled,
  value,
  checked,
}) => (
  <div className="progression-checkbox">
    <input
      type="checkbox"
      name={name}
      id={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      tabIndex="-1"
    />

    {!!children && (
      <label htmlFor={name} className="text">
        {children}
      </label>
    )}
  </div>
);

export default ProgressionCheckbox;
